


<a routerLink="/portfolios">
    <svg class="marg-t-15 me-1" x="0" y="0" height="27" width="27" viewBox="0 0 100 100">
        <g>
            <circle r="50" transform="translate(50 50)" fill="#fff"></circle>
            <path d="M38.4,46.1l-2-1.5c3-3.3,5.8-5.7,8.3-7.1c2.5-1.4,4.6-2.1,6.4-2.1c1,0,1.7,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.7
                    c0,0.9-1,4.6-2.9,11.1c-3.2,10.7-4.8,17.2-4.8,19.4c0,0.4,0.1,0.8,0.3,1.1c0.2,0.3,0.4,0.4,0.7,0.4c1,0,3.4-1.9,7.4-5.6l1.8,1.7
                    c-4.1,3.9-7.2,6.4-9.1,7.5C45.6,74.4,44,75,42.8,75c-1.1,0-1.9-0.3-2.5-1c-0.6-0.7-0.9-1.6-0.9-2.8c0-3.8,2.3-13,6.8-27.7
                    c0.2-0.7,0.3-1.3,0.3-1.9c0-0.6-0.3-0.9-0.8-0.9c-0.6,0-1.3,0.2-2.1,0.7C42.8,42,41.1,43.5,38.4,46.1z M56.3,16.1
                    c0.9,0,1.7,0.3,2.3,0.9c0.6,0.6,0.9,1.4,0.9,2.4c0,1.3-0.5,2.5-1.4,3.5c-0.9,1-2,1.5-3.1,1.5c-0.9,0-1.7-0.3-2.3-1
                    c-0.6-0.6-0.9-1.5-0.9-2.5c0-1.4,0.4-2.5,1.3-3.5C54,16.6,55,16.1,56.3,16.1z"></path>
        </g>
    </svg>
</a>
<a *ngFor="let n of [0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,95,100]" routerLink="/portfolios/{{n}}" (click)="ballClick(n)">
    <app-svg-sprite-v2 title="IFA Index Portfolio {{n}}" [width]="30" [height]="30" [hash]="`#${prefix}${n}${suffix}`" style="margin:0 1px 0 0"></app-svg-sprite-v2>
</a>
<!-- <a *ngFor="let n of [95,100]" routerLink="{{pre + n + post}}" (click)="ballClick(n)">
    <app-svg-sprite-v2 title="IFA Index Portfolio {{n}}" [width]="30" [height]="30" [hash]="`#${prefix}${n}${suffix}`" style="margin:0 1px 0 0"></app-svg-sprite-v2>
</a> -->